import * as z$1 from "zod/v4";
//#region src/schemas/runtime/working-language.ts
const WORKING_LANGUAGE_TAG_MAX_CHARS = 64;
const workingLanguageTagSchema = z$1.string().trim().min(2).max(64).transform((value, context) => {
	try {
		const [canonical] = Intl.getCanonicalLocales(value);
		if (!canonical) throw new TypeError("A language tag is required.");
		return canonical;
	} catch {
		context.addIssue({
			code: "custom",
			message: "Expected a valid BCP 47 language tag."
		});
		return z$1.NEVER;
	}
});
const organizationWorkingLanguageModeSchema = z$1.enum(["automatic", "selected"]);
const workingLanguageGuidanceSchema = z$1.strictObject({
	languageTag: workingLanguageTagSchema,
	mode: organizationWorkingLanguageModeSchema
});
//#endregion
export { WORKING_LANGUAGE_TAG_MAX_CHARS, organizationWorkingLanguageModeSchema, workingLanguageGuidanceSchema, workingLanguageTagSchema };

//# sourceMappingURL=working-language.js.map